import React, { Suspense } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";

import DanGNelson from "./views/DanGNelson";

function Loader() {
  return (
    <div className="h-100 d-flex align-items-center justify-content-center">
      <i className="fa-solid fa-spinner fa-spin-pulse" />
    </div>
  );
}

function AppRoutes() {
  return (
    <HashRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<Loader />}>
              <DanGNelson />
            </Suspense>
          }
        />
      </Routes>
    </HashRouter>
  );
}

export default AppRoutes;
